<i18n>
{
  "fr": {
    "zendesk_button": {
      "label": "Chat"
    }
  }
}
</i18n>

<template>
  <button type="button" class="zendesk-button" @click="openZendesk">
    <span
      class="zendesk-button__label"
      v-text="$t('zendesk_button.label')"
    ></span>
  </button>
</template>

<script>
export default {
  name: 'ZendeskButton',
  data() {
    return {
      isZendeskActive: false,
      zendeskReady: false,
    };
  },
  watch: {
    isZendeskActive: {
      handler(isZendeskActive) {
        if (!globalThis.zE) {
          return;
        }

        if (isZendeskActive) {
          // Show the widget first (it's hidden by default), then open it
          globalThis.zE('webWidget', 'show');
          globalThis.zE('webWidget', 'open');
        } else {
          // Close and hide the widget completely
          globalThis.zE('webWidget', 'close');
          globalThis.zE('webWidget', 'hide');
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initZendeskListeners();
  },
  methods: {
    initZendeskListeners() {
      // If Zendesk is already loaded, bind the close event
      if (globalThis.zE) {
        this.bindCloseEvent();
        this.zendeskReady = true;
        return;
      }

      // Otherwise, wait for the script to load (lazy loaded on mouse/touch move)
      const checkZendesk = setInterval(() => {
        if (globalThis.zE) {
          clearInterval(checkZendesk);
          this.bindCloseEvent();
          this.zendeskReady = true;
        }
      }, 500);
    },
    bindCloseEvent() {
      globalThis.zE('webWidget:on', 'close', () => {
        this.setZendeskState(false);
      });
    },
    openZendesk() {
      this.setZendeskState(true);
    },
    setZendeskState(value = true) {
      this.isZendeskActive = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.zendesk-button {
  $vertical-padding: 0.75em;
  $height: 1em * $base-line-height + 2 * $vertical-padding;

  color: $color-primary-invert;
  background-color: $color-primary;
  border: none;
  font: inherit;
  line-height: inherit;
  min-height: $height;
  min-width: $height;
  cursor: pointer;
  padding: $vertical-padding;
  display: inline-flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  border-radius: math.div($height, 2);
  -webkit-tap-highlight-color: transparent;

  @include breakpoint($breakpoint-configurator-l) {
    padding: 0.5em 1em;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: color.adjust($color-primary, $lightness: 10%);
  }

  &::before {
    @extend %icon;
    @extend %icon--zendesk-chat;

    display: inline-block;
  }

  &__label {
    @include sr-only();

    @include breakpoint($breakpoint-configurator-l) {
      clip: auto;
      height: auto;
      margin: 0;
      overflow: visible;
      position: static;
      white-space: inherit;
      width: auto;
      margin-left: 0.5em;
    }
  }
}
</style>
